import WebViewer from '@pdftron/webviewer'
import {getAnnotation} from '../dataSource/webViewer'


/*
Load File API:
http://172.16.145.30:3003/api/v1/dms/property/download?property_seq=${propertySeq}&only_primary=true
http://172.16.145.30:3003/api/v1/dms/property/${propertySeq}/file/download?property_file_seq=${propertyFileSeq}
http://172.16.145.30:3002/api/v1/file/download?file_cat=${fileCategory}&file_seq=${fileSeq}
*/

const webViewerLoadCircDocument = (type, filePreviewProperty) => {
	const store = require('store')
	const instance = WebViewer.getInstance(document.getElementById('webviewer'))
	const {docViewer, annotManager} = instance

	store.set('annotActive', false)

	if (instance === null) {
		console.error("Cannot get the WebViewer Instance!")
		return
	}

	// getAnnotation({
	// 	file_ref: fileSeq,
	// 	file_cat: fileCategory
	// }).then(annotString => {

		instance.loadDocument(
			type === "CIRC" ? 
				`${process.env.REACT_APP_API_URL_3006}/circulation/${filePreviewProperty.circulationSeq}/${filePreviewProperty.CirculationMessageSeq}/attachment/${filePreviewProperty.messageFileSeq}`
			: "", {
			
			filename: filePreviewProperty.filename,

			customHeaders: {
				"Authorization": "Bearer " + store.get('access_token'),
				"site": store.get('site'),
				"locale": store.get('locale')
			}
		})

		// docViewer.on('documentLoaded', () => {

		// 	annotManager.on('annotationChanged', (annotations, action, {imported}) => {
		// 		if (imported) {
		// 			store.set('annotActive', false)

		// 			// console.log("annotActive => " + store.get('annotActive') + "|| import => " + imported)

		// 			return
		// 		}

		// 		if (action === 'add') {
		// 			console.log('this is a change that added annotations')
		// 			// annotActive = true
		// 			store.set('annotActive', true)

		// 			// console.log("action => add || annotActive => " + store.get('annotActive'))

		// 		}
		// 		else if (action === 'modify') {
		// 			console.log('this change modified annotations')
		// 			// annotActive = true
		// 			store.set('annotActive', true)

		// 			// console.log("action => modify || annotActive => " + store.get('annotActive'))

		// 		}
		// 		else if (action === 'delete') {
		// 			console.log('there were annotations deleted')
		// 			// annotActive = true
		// 			store.set('annotActive', true)

		// 			// console.log("action => delete || annotActive => " + store.get('annotActive'))
		// 		}
		// 	})

		// 	annotManager.deleteAnnotations(annotManager.getAnnotationsList())
		// 	annotString.data.length > 0 ? annotManager.importAnnotations(annotString.data[0].annotation) : annotManager.importAnnotations("")

		// 	// annotManager.exportAnnotCommand().then(temp => {
		// 	// 	console.log("########## exportAnnotCommand")
		// 	// 	console.log(temp)
		// 	// })


		// })
	// })

	// return annotActive
}


export {webViewerLoadCircDocument}